/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/warehouses/', params);
}

function get(id, params) {
  return api.get(`/warehouses/${id}`, params);
}

function load(id, params) {
  return api.get(`/warehouses/${id}/load`, params);
}

function saveLoad(id, params) {
  return api.post(`/warehouses/${id}/load`, params);
}

function unload(id, params) {
  return api.get(`/warehouses/${id}/unload`, params);
}

function saveUnload(id, params) {
  return api.post(`/warehouses/${id}/unload`, params);
}

function saveUnloadDocument(id, params) {
  return api.post(`/warehouses/${id}/unload-document`, params);
}

function saveUnloadScan(id, params) {
  return api.post(`/warehouses/${id}/unload-scan`, params);
}

function transfer(id, params) {
  return api.get(`/warehouses/${id}/transfer`, params);
}

function saveTransfer(id, params) {
  return api.post(`/warehouses/${id}/transfer`, params);
}

function saveTransferAll(id, params) {
  return api.post(`/warehouses/${id}/transfer-all`, params);
}

function product(id, params) {
  return api.get(`/warehouses/${id}/product`, params);
}

function moviments(params) {
  return api.get('/warehouses-moviments/', params);
}

function create(params) {
  return api.post('/warehouses', params);
}

function update(id, params) {
  return api.put(`/warehouses/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/warehouses/${id}`, params);
}

function reset(id, params) {
  return api.post(`/warehouses/${id}/reset`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function updateProductLocation(id, productId, params) {
  return api.put(`/warehouses/${id}/product/${productId}`, params);
}

function getProductInfo(id, productId, params) {
  return api.get(`/warehouses/${id}/product/${productId}`, params);
}

function importLoad(id, params) {
  return api.post(`/warehouses/${id}/import-load`, params);
}

function productQuantityAvailableInWarehouse(id, params) {
  return api.get(`/warehouses/${id}/product-qty`, params);
}

export const warehousesService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  load,
  saveLoad,
  unload,
  saveUnload,
  transfer,
  saveTransfer,
  product,
  moviments,
  updateProductLocation,
  getProductInfo,
  saveUnloadDocument,
  importLoad,
  saveUnloadScan,
  reset,
  saveTransferAll,
  productQuantityAvailableInWarehouse,
};
